import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "antd/dist/antd.css";
import { Provider } from 'react-redux';
import rootReducer from './ReduxStore/reducers/rootReducer';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { HelmetProvider } from 'react-helmet-async';

// Browser page translation (Chrome / Google Translate) moves page text into
// <font> tags. When React later removes or inserts next to that text the node
// is no longer where React left it and React throws, blanking the whole page.
// Known React issue (facebook/react#11538); this is the usual workaround.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.apply(this, arguments);
  };
}

const store = createStore(rootReducer, applyMiddleware(thunk));
// store.subscribe(() => {
//   console.log("store updated");
//   console.log(store.getState());
// })
ReactDOM.render(
  <>
    <React.StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </React.StrictMode>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
